<template>
  <div>
    <InstructionViewPublisher
      v-if="isEditorOrPublisher"
      ref="instructionViewPublisher"
      :task="task"
      :read-only="readOnly"
    />
    <InstructionViewInspector
      v-else
      ref="instructionViewInspector"
      :task="task"
      :read-only="readOnly"
    />
  </div>
</template>

<script>
import InstructionViewPublisher from './InstructionViewPublisher';
import InstructionViewInspector from './InstructionViewInspector';
import ConflictDialog from '../../ConflictDialog';
import {
  WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION,
  WEBSOCKET_EVENT_UNSUBSCRIBE_FROM_ACTION,
} from '../../../store/websocket/actions/actionTypes';
import { GET_QUESTIONS } from '../../../store/questions/actions/actionTypes';

export default {
  components: {
    InstructionViewPublisher,
    InstructionViewInspector,
    ConflictDialog,
  },
  data() {
    return {
      conflictDialogVisible: false,
      instructionConflicts: [],
    };
  },
  computed: {
    isEditorOrPublisher() {
      return this.viewType === 'publisher' || this.viewType === 'editor';
    },
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    viewType: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onSave() {
      if (this.isEditorOrPublisher) {
        this.$refs.instructionViewPublisher.forceSave();
      } else {
        this.$refs.instructionViewInspector.forceSave();
      }
    },
    async refreshQuestions() {
      await this.$store.dispatch(GET_QUESTIONS, this.task._id);
    },
  },
  async created() {
    const wsMappings = {
      questionCreated: this.refreshQuestions,
      questionDeleted: this.refreshQuestions,
      questionUpdated: this.refreshQuestions,
    };
    await Promise.all(
      Object.keys(wsMappings).map((key) =>
        this.$store.dispatch(WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION, {
          action: key,
          callback: wsMappings[key],
        })
      )
    );
  },
  beforeDestroy() {
    const wsMappings = {
      questionCreated: this.refreshQuestions,
      questionDeleted: this.refreshQuestions,
      questionUpdated: this.refreshQuestions,
    };
    Promise.all(
      Object.keys(wsMappings).map((key) =>
        this.$store.dispatch(WEBSOCKET_EVENT_UNSUBSCRIBE_FROM_ACTION, {
          action: key,
          callback: wsMappings[key],
        })
      )
    );
  },
};
</script>
